<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Title / Tên phòng ban" prop="name">
        <a-input ref="name" v-model="form.name" placeholder="Enter title" />
      </a-form-model-item>
      <a-form-model-item
        label="Belong to department / Thuộc phòng ban"
        prop="parentId"
      >
        <SelectDepartment
          v-model="form.parentId"
          :selectProps="{
            value: form.parentId,
            placeholder: 'Department',
          }"
        />
      </a-form-model-item>

      <a-form-model-item label="Manager / Người quản lý" prop="managerIds">
        <SelectUser
          v-model="form.hrReporterIds"
          :selectProps="{
            value: form.hrReporterIds,
            placeholder: 'Select users',
            mode: 'multiple',
          }"
          :variablesQuery="{
            hasEmployee: undefined,
          }"
        />
      </a-form-model-item>

      <a-form-model-item label="Permission View Report / Quyền xem báo cáo">
        <SelectUser
          v-model="form.managerIds"
          :selectProps="{
            value: form.managerIds,
            placeholder: 'Select users',
            mode: 'multiple',
          }"
          :variablesQuery="{
            hasEmployee: undefined,
          }"
        />
      </a-form-model-item>

      <!-- <a-form-model-item label="Helper / Người tạo hộ" prop="managerIds">
        <SelectUser
          v-model="form.createHelperIds"
          :selectProps="{
            value: form.createHelperIds,
            placeholder: 'Select users',
            mode: 'multiple',
          }"
          :variablesQuery="{
            hasEmployee: undefined,
          }"
        />
      </a-form-model-item> -->

      <a-form-model-item label="Shift / Ca làm việc" prop="managerIds">
        <SelectWorkShift
          v-model="form.workShiftIds"
          :selectProps="{
            value: form.workShiftIds,
            placeholder: 'Select shifts',
            mode: 'multiple',
          }"
        />
      </a-form-model-item>

      <a-form-model-item has-feedback label="Active" prop="status">
        <a-switch
          size="default"
          @change="onChangeDepartment"
          :defaultChecked="true"
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Document">
        <a-checkbox v-model="form.canShowOnDocument">
          Show on document
        </a-checkbox>
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button
        @click="closeDrawerAddDepartment"
        icon="close"
        style="margin-right: 5px;"
      >
        Close
      </a-button>
      <a-button
        type="primary"
        @click="createDepartment"
        icon="plus"
        :loading="iconLoading"
      >
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import postQuery from "../../data/postData";
import SelectDepartment from "@/components/common/department/select";
import SelectUser from "@/components/common/user/select";
import SelectWorkShift from "@/components/common/workShift/select";

const defaultForm = {
  name: null,
  status: "ACTIVE",
  parentId: undefined,
  managerIds: [],
};

export default {
  components: { SelectDepartment, SelectUser, SelectWorkShift },
  props: {
    closeDrawerAddDepartment: {
      type: Function,
      default: null,
    },
    createdDepartmentUpdateOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: { ...defaultForm },
      rules: {
        name: [
          {
            required: true,
            message: "Required / Tên phòng ban không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    onChangeDepartment(checked) {
      if (checked) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },
    createDepartment() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form?.status
            ? this.form.status
            : this.$set(this.form, "status", "ACTIVE");
          this.iconLoading = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryCreateDepartment,
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createDepartment) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });
                this.form = { ...defaultForm };
                this.onFocusRefName();
                this.createdDepartmentUpdateOnView(data.createDepartment);
              }
              this.iconLoading = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!" + error,
              });
              console.log("Không lấy được danh sách phòng ban", error);
              this.iconLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    onFocusRefName() {
      this.$nextTick(() => {
        if (this.$refs?.name) {
          this.$refs.name.focus();
        }
      });
    },
  },
};
</script>
<style></style>
